<template>
  <div class="mt-4 grid grid-cols-3 gap-4">
    <base-course-card
      v-for="course in courseList"
      :key="course.id"
      :course="course"
      :onClick="() => onClickCourseCard(course.id)"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import BaseCourseCard from './BaseCourseCard.vue'

import { useCoursePresenter } from '@/presentation/composables/problem/useCoursePresenter'

export default defineComponent({
  components: {
    BaseCourseCard
  },
  props: {
    onClickCourseCard: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const coursePresenter = useCoursePresenter()

    const courseList = computed(() =>
      Object.values(coursePresenter.courseList.value).sort((a, b) => a.serial - b.serial)
    )

    return {
      courseList
    }
  }
})
</script>

<style lang="postcss" scoped></style>
